import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["min", "max", "minLabel", "maxLabel"];
  static values = {
    sliderColor: {
      type: String,
      default: "#626262",
    },
    rangeColor: {
      type: String,
      default: "#45ae5c",
    },
    minCur: Number,
    maxMin: Number,
    maxCur: Number,
    maxMax: Number,
  };

  connect() {
    this.update();
  }

  update(event) {
    if (this.updating) return;

    this.updating = true;
    this.minCurValue = this.minTarget.value;
    this.maxCurValue = this.maxTarget.value;
    this.maxMinValue = this.maxTarget.getAttribute("min");
    this.maxMaxValue = this.maxTarget.getAttribute("max");

    if (event?.target === this.minTarget) {
      if (this.minCurValue > this.maxCurValue) {
        this.minCurValue = this.maxCurValue;
        this.minTarget.value = this.maxCurValue;
      }
    } else if (event?.target === this.maxTarget) {
      if (this.minCurValue > this.maxCurValue) {
        this.maxCurValue = this.minCurValue;
        this.maxTarget.value = this.minCurValue;
      }
    }

    this.minLabelTarget.innerText = this.minTarget.value;
    this.maxLabelTarget.innerText = this.maxTarget.value;

    const minPosition = this.minCurValue - this.maxMinValue;
    const maxPosition = this.maxCurValue - this.maxMinValue;
    const rangeDistance = this.maxMaxValue - this.maxMinValue;

    this.maxTarget.style.background = `linear-gradient(
      to right,
      ${this.sliderColorValue} 0%,
      ${this.sliderColorValue} ${(minPosition / rangeDistance) * 100}%,
      ${this.rangeColorValue} ${(minPosition / rangeDistance) * 100}%,
      ${this.rangeColorValue} ${(maxPosition / rangeDistance) * 100}%,
      ${this.sliderColorValue} ${(maxPosition / rangeDistance) * 100}%,
      ${this.sliderColorValue} 100%)`;
    this.updating = false;
  }
}
